import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const ContactUs = () => {
  return (
    <Box
      sx={{
        fontFamily: "Roboto, Arial, sans-serif",
        textAlign: "center",
        padding: 1,
        backgroundColor: "transparent",
        
      }}
    >
        
        <IconButton
          href="https://www.linkedin.com/company/noterefinery/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company_admin_dashboard_index%3BwjMZurkDTNqsQFgiykStFw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "#492099" }}
        >
          <LinkedInIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Typography
          variant="body2"
          sx={{ marginTop: 1, color: "#492099", fontSize: "0.9rem" }}
        >
          Connect with us on LinkedIn
        </Typography>
    </Box>
  );
};

export default ContactUs;
